import { setGlobal } from 'reactn'

export const changeShouldRefreshNotifications = async (input: boolean) => {
  await setGlobal({
    shouldRefreshNotifications: input,
  })
}
